import * as Sentry from '@sentry/react';

import { HandledSentryErrorType } from './sentry.types';

export const logSentryMessage = (
  handledErrorType: HandledSentryErrorType,
  extra?: Record<string, unknown>,
): void => {
  if (process.env.MODE === 'local') {
    // eslint-disable-next-line no-console
    console.log(
      `Sentry message: ${handledErrorType}, extra: ${JSON.stringify(extra)}`,
    );
  } else {
    Sentry.captureMessage(handledErrorType, extra);
  }
};
